import { CommonModule }            from '@angular/common';
import { NgModule }                from '@angular/core';
import { NgbCollapseModule }       from '@ng-bootstrap/ng-bootstrap';
import { DownloadButtonComponent } from '@shared/components/download-button/download-button.component';
import { SvgModule }               from '@shared/components/svg/svg.module';
import { NgClickOutsideDirective } from 'ng-click-outside2';

@NgModule( {
	declarations: [
		DownloadButtonComponent
	],
	exports: [
		DownloadButtonComponent
	],
	imports: [
		// Angular
		CommonModule,

		// Third Party
		NgClickOutsideDirective,
		NgbCollapseModule,

		// Shared
		SvgModule
	],
	providers: []
} )
export class DownloadButtonModule {}
